import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-web-developer-resume',
  templateUrl: './web-developer-resume.component.html',
  styleUrls: ['./web-developer-resume.component.css']
})
export class WebDeveloperResumeComponent implements OnInit {

  profile: any = {
    logo: "logo-black-5.png",
    profile: "web-developer"
  };

  page_banner: any = {
    title: "Resume",
    profile: "web-developer",
  };

  member: any = {
    image: "bp.png",
    logo: "",
    designation: "",
    age: "36",
    dob: "05.11.1984",
    residence: "SWITZERLAND",
    address: "FARVAGNY, SWITZERLAND",
    email: "bertrandpetit10@gmail.com",
    phone: "(+41) 79 402 88 04",
    skype: "ALEX.SMITH",
    whatsapp: "",
    about_me: 'Hi! My name is <span class="text-primary">Bertrand Petit</span>. I am a Junior Web Developer, and I\'m very passionate and dedicated to my work. After 12 years in the business of digital advertising printing, I decided to make my new passion my job. Passionate about computers, video games and reading, I have learned web development on my own since 2020.',
    intrests: "WEB DEVELOPMENT, VIDEO GAMES, READING",
    name: "Bertrand Petit",
    study: "UNIVERSITY OF CHICAGO",
    highes_degree: "MASTER",
    profile: "web-developer"
  };

  skills: any = [
    {
      title: "Angular 11 / RXJS / NGRX / Ionic",
      score: "80",
    },
    {
      title: "JavaScript/Typescript",
      score: "70",
    },
    {
      title: "HTML5 / CSS3 / Bootstrap",
      score: "70",
    },
    {
      title: "NodJS / ExpressJS",
      score: "60",
    },
    {
      title: "NoSQL / MongoDB",
      score: "60",
    },
    {
      title: "GitHub",
      score: "60",
    },
    {
      title: "Socket.IO",
      score: "50",
    },
    {
      title: "SQL / MySQL",
      score: "40",
    },
    {
      title: "PhP / Laravel",
      score: "30",
    },
    {
      title: "Python / Django",
      score: "30",
    },

  ];

  education: any = [
    {
      title: "Various online training courses in application development",
      year: "2020",
      organization_name: "Internet",
      description: "HTML, CSS, Bootstrap, Javascript, Typescript, MongoDB, ExpressJS, Angular, RXJS, NGRX, NodeJS, Ionic, Socket.IO, API Rest, MVC architecture, PhP, MySQL, Laravel, Python, Django.",
    },
    {
      title: "Professional Qualifications Certificate TEDIM : TEchnicien de Développement informatique Industrielle dans la Mécanique",
      year: "2008",
      organization_name: "CCI Reunion Island - AFIP Lyon France",
      description: "Project management, Development of web applications, SolidWorks and Pro-Engineer 3D graphics.",
    },
    {
      title: "Application Developer Training",
      year: "2006",
      organization_name: "CCI Reunion Island, France",
      description: "Introduction to programming languages, Application development.",
    },
    {
      title: "Baccalauréat Professionnel MRIM",
      year: "2003",
      organization_name: "CFAI Cluses, France",
      description: "Work-study internship (Professional Maturity Equivalent) Micro-computing and Networks: Installation and maintenance.",
    },
  ];
  experience: any = [
    {
      title: "Head of printing sector",
      year: "2016-2020",
      organization_name: "Cesa Créations Enseignes SA, Swituerland",
      description: "Digital machine opérator, PAO/CAO operator, creation, manufacture, installation, IT maintenance level 1 and 2.",
    },
    {
      title: "Workshop chief",
      year: "2008-2016",
      organization_name: "Imprimerie Sérigraphique du Léman, France",
      description: "Digital machine operator, PAO/CAO operator, creation, manufacture, installation, IT maintenance level 1 and 2, Website creation and maintenance.",
    },
    {
      title: "Trainee",
      year: "2007-2008",
      organization_name: "Europoly, France",
      description: "3D technical drawings trainee",
    },
    {
      title: "Work-study apprenticeship",
      year: "2001-2003",
      organization_name: "MP&CO, France",
      description: "Management of printing colorimetry, computer maintenance",
    },
  ];
  language_known: any = [
    {
      title: "French",
      score: "100",
    },
    {
      title: "English",
      score: "60",
    },
    {
      title: "Spanish",
      score: "15",
    }
  ];

  knowledge: any = [
    "Angular",
    "RXJS",
    "NGRX",
    "Ionic",
    "NodeJS",
    "ExpressJS",
    "Socket.IO",
    "GitHub",
    "MongoDB",
    "HTML",
    "CSS",
    "Javascript",
    "Typescript",
    "Adobe Illustrator",
    "Adobe Photoshop",
    "MacOS",
    "Linux",
    "Windows",
    "Website hosting",
    "iOS and android apps",
    "AWS EC2, S3, EBS, Amplify",
    "Customer Service",
    "Problem Solving"
  ];


  constructor() { }

  ngOnInit(): void {
  }

}
